import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ArchivedSummary as CredentialVerificationArchivedSummary } from './credential-verification/archive/pages/archived-summary';
import { CredentialVerificationVersionRouter } from './credential-verification/version-router';
import { ArchivedSummary as IdentityVerificationArchivedSummary } from './identity-verification/archive/pages/archived-summary';
import { IdentityVerificationVersionRouter } from './identity-verification/version-router';
import { CaseSearch } from '../staff/pages/case-search';
import { ArchivedSummary as SendReportArchivedSummary } from './send-report/archive/pages/archived-summary';
import { SendReportVersionRouter } from './send-report/version-router';
import { Helmet } from 'react-helmet';

export const Cases: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Cases</title>
      </Helmet>
      <Routes>
        <Route path="/:caseId/case-type/credential-verification/active/*" element={<CredentialVerificationVersionRouter />} />
        <Route path="/:caseId/case-type/credential-verification/archived/*" element={<CredentialVerificationArchivedSummary />} />
        <Route path="/:caseId/case-type/send-report/active/*" element={<SendReportVersionRouter />} />
        <Route path="/:caseId/case-type/send-report/archived/*" element={<SendReportArchivedSummary />} />
        <Route path="/:caseId/case-type/id-verification/active/*" element={<IdentityVerificationVersionRouter />} />
        <Route path="/:caseId/case-type/id-verification/archived/*" element={<IdentityVerificationArchivedSummary />} />
        <Route path="*" element={<CaseSearch />} />
      </Routes>
    </>
  );
};

